<template>
  <div class="window-contain">
    <div class="window">
      <!-- Header -->
      <header class="window-header">
        <the-window-header
          :isStatus="isStatus"
          :open="open"
          @handleNotice="handlenotice"
          :selectUser="selectUserInfo"
        ></the-window-header>
      </header>

      <section class="window-content">
        <!-- Aside Left -->
        <aside class="window-aside--left">
          <the-window-aside-left
            :current="sessionID"
            @change="changeSession"
            :messageUserId="messageUserId"
            ref="user"
          ></the-window-aside-left>
        </aside>

        <!-- Main -->
        <main class="window-main">
          <the-window-main
            :to-id="sessionID"
            :from-id="messageUserId"
            ref="chat"
            :select-user="selectUserInfo"
          ></the-window-main>
        </main>

        <!-- Aside Right -->
        <!-- <aside class="window-aside--right">
          <the-window-aside-right :to-id="sessionID"></the-window-aside-right>
        </aside> -->
      </section>
      <!-- <div @click="postMessage">传值</div> -->
      <!-- <iframe id="iframe" class="window-iframe" src="http://192.168.2.218:9999/" frameborder="0" ref="iframe" style="width: 100%; height: 500px;"></iframe> -->
    </div>
    <!-- 提示音 -->
    <easy-ring
      log
      :open="open"
      :ring.sync="ring"
      :loop="false"
      :src="notice"
      ref="ring"
    />
    <!-- 获取声音提示弹框 -->
    <el-dialog width="20%" :visible="showDialog" :show-close="false">
      是否允许开启音效
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">拒 绝</el-button>
        <el-button type="primary" @click="handlevisible">同 意</el-button>
      </span>
    </el-dialog>
    <!-- 视频播放 -->
    <el-dialog width="40%" title="查看视频" :visible="showVideoDialog" @close="handleVideoVisible">
      <video ref="video" class="video-player" controls :src="videoUrl"></video>
    </el-dialog>
  </div>
</template>

<script>
import TheWindowHeader from "./components/TheWindowHeader";
import TheWindowMain from "./components/TheWindowMain";
import TheWindowAsideLeft from "./components/TheWindowAsideLeft";
import TheWindowAsideRight from "./components/TheWindowAsideRight";

import Socket from "@/utils/socket";
import config from "@/config.js";
import { E_Msg, E_MsgEvent, terminal } from "@/utils/enum";
import { getUrlParams } from "@/utils/util";
import { mapGetters, mapActions } from "vuex";
import { EasyRingVueComponent as EasyRing } from "easy-ring";
import { Howl, Howler } from 'howler';

export default {
  name: "Window",

  components: {
    TheWindowHeader,
    TheWindowAsideLeft,
    TheWindowAsideRight,
    TheWindowMain,
    EasyRing,
  },

  data() {
    return {
      sessionID: "",
      isStatus: false,
      //提示音相关
      open: false,
      ring: false,
      notice: require("@/assets/message.mp3"),
      showDialog: false,
      selectUserInfo: {}, // 选中的用户信息
      videoUrl: '', // 视频地址
      showVideoDialog: false, // 视频弹窗是否显示
      option: {}, // 选项参数
      messageUserId: ''
    };
  },

  computed: {
    ...mapGetters(["token", "userInfo", "wsUrl"])
  },

  provide() {
    return {
      sendMessage: this.sendMessage,
      send: this.send,
      closeChatServe: this.closeChatServe,
      reChatServe: this.reChatServe,
      playVoice: this.playVoice,
      playVideo: this.playVideo,
    };
  },

  async created() {
    // await this.getUserInfo();
    this.option = getUrlParams();
    this.messageUserId = await this.$store.dispatch('getMessageUserId')
    console.log('开始获取messageUserId', this.messageUserId)
    await this.initChatServe();
  },
  beforeDestroy() {
    this.closeChatServe();
  },
  methods: {
    handlenotice() {
      this.open = !this.open;
    },
    /**
     * 开启声音
     */
    handlevisible() {
      this.open = true; // ① 开启组件
      this.showDialog = false;
    },
    openComponent() {},
    ...mapActions(["getUserInfo"]),
    /**
     * 发送消息
     */
    sendMessage(data) {
      this.send(E_MsgEvent["CHAT"], data);
    },

    /**
     * 通用发送
     */
    send(event, data) {
      this.socketServe.send(data);
      // this.$refs.ring.stopRing();
      // this.test = false;
    },

    // 关闭连接
    closeChatServe() {
      this.socketServe.close();
    },

    // 重新连接
    reChatServe() {
      this.socketServe.init();
    },

    /**
     * 初始化聊天服务
     */
    initChatServe() {
      return new Promise((resolve, reject) => {
        const _this = this;
        this.socketServe = new Socket({
          ws: config.wsURL,

          params: {
            id: _this.messageUserId,
            source: "h5"
          },

          open() {
            _this.isStatus = true;
            resolve();
          },

          message({ data }) {
            const { type } = JSON.parse(data) || {};
            // console.log("e", type);
            switch (type) {
              case E_MsgEvent["CHAT"]:
                _this.ring = true;
                _this.$refs["chat"].$emit("message", JSON.parse(data));
                _this.$refs["user"].$emit("message", JSON.parse(data));
                break;
              case E_MsgEvent["ERROR"]:
                _this.$message.error(content.msg);
                break;
              case E_MsgEvent["NOTICE"]:
                _this.$message.info(content.msg);
                break;
              case E_MsgEvent["PING"]:
                // console.log("===============心跳============");
                break;
              case E_MsgEvent["USER_ONLINE"]:
                _this.$refs["user"].$emit("useronline", content);
                break;
              case E_MsgEvent["TRANSFER"]:
                _this.$refs["user"].$emit("transfer", content);
                break;
            }
          },

          error(e) {
            reject();
          },

          close() {
            _this.isStatus = false;
          },
        });
      });
    },

    /**
     * 切换会话
     */
    changeSession(userID, userInfo) {
      this.sessionID = userID;
      console.log('切换会话', userID, userInfo)
      this.selectUserInfo = userInfo;
    },
    /**
     * 播放语音
     */
    playVoice(url) {
      const that = this
      if (this.sound) this.sound.unload();
      this.sound = new Howl({
        src: [url],
        volume: 0.5,
        html5: true,
        preload: true,
        onend: function() {
          console.log('语音播放完毕!');
          that.sound.unload()
          that.$refs.chat.restVoiceId();
        }
      });
      this.sound.play();
    },
    /**
     * 播放视频
     */
    playVideo(url) {
      this.videoUrl = url;
      this.showVideoDialog = true;
      setTimeout(() => {
        this.$refs.video.play();
      }, 500);
    },
    /**
     * 视频播放结束
     */
    handleVideoVisible() {
      this.showVideoDialog = false;
      this.$refs.video.pause();
      this.$refs.video.currentTime = 0;
    },
    postMessage() {
      this.$refs.iframe.contentWindow.postMessage('hello111 world', '*');
    }
  },
  mounted() {
    this.showDialog = false;
  },
};
</script>

<style lang="scss" scoped>
.window-contain {
  $--window-width: 100%;
  $--window-height: 100%;

  $--window-header-height: 60px;
  $--window-aside-l-width: 300px;
  $--window-aside-r-width: 240px;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  .window {
    display: flex;
    flex-direction: column;
    width: $--window-width;
    height: $--window-height;
    background-color: #ffffff;

    &-header {
      height: $--window-header-height;
    }

    &-content {
      flex: 1;
      display: flex;
      flex-direction: row;

      .window-aside {
        &--left {
          width: $--window-aside-l-width;
          border-right: 1px solid $--border-color-base;
        }

        &--right {
          width: $--window-aside-r-width;
          border-left: 1px solid $--border-color-base;
        }
      }

      .window-main {
        flex: 1;
      }
    }
  }
  
  .video-player {
    width: 100%;
    height: 400px;
    background: #000000;
  }
}
</style>
